import {Injectable} from '@angular/core';
import {Service} from '../common/service.class';
import {UserModelService} from '../common/user-model.service';
import {ProfessionalLiability} from './professional-liability.model';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
@Injectable()
export class ProfessionalLiabilityService extends UserModelService<ProfessionalLiability> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'professionalLiability', ProfessionalLiability);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/liability/professional-liability.service.ts